import { render, staticRenderFns } from "./DealerNotes.vue?vue&type=template&id=38141c8c&scoped=true"
import script from "./DealerNotes.vue?vue&type=script&lang=js"
export * from "./DealerNotes.vue?vue&type=script&lang=js"
import style0 from "./DealerNotes.vue?vue&type=style&index=0&id=38141c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38141c8c",
  null
  
)

export default component.exports